import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { SiteHeader } from './SiteHeader';
import { SiteFooter } from './SiteFooter';
import { usePageMeta } from '@/hooks/usePageMeta';

export const NotFoundPage = () => {
  usePageMeta({
    title: '404 — Graves Collective',
    description: 'The page you’re looking for has wandered off.',
  });

  return (
    <div className="min-h-screen bg-cream text-ink flex flex-col" data-testid="page-404">
      <SiteHeader />
      <section className="flex-1 max-w-[1400px] mx-auto px-6 sm:px-10 lg:px-16 py-24 lg:py-40 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
        <div className="lg:col-span-7">
          <p className="text-[11px] uppercase tracking-[0.24em] text-soft mb-6">
            404
          </p>
          <h1 className="font-display text-6xl lg:text-7xl xl:text-8xl leading-[0.95] tracking-tight text-ink">
            This page <span className="italic text-terracotta">wandered off.</span>
          </h1>
          <p className="mt-8 text-lg text-soft max-w-xl leading-relaxed">
            Maybe it’s out riding horses. Either way, you can head back to the
            studio shop or browse a collection below.
          </p>
          <div className="mt-12 flex flex-wrap gap-6">
            <Link
              to="/"
              className="inline-flex items-center gap-3 px-8 py-4 text-sm uppercase tracking-[0.18em] bg-ink text-cream hover:bg-terracotta transition-colors group"
              data-testid="404-home-cta"
            >
              Back to home
              <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
            </Link>
            <Link
              to="/studio"
              className="inline-flex items-center gap-3 text-sm uppercase tracking-[0.18em] text-ink hover:text-terracotta transition-colors py-4"
            >
              Browse the studio
            </Link>
          </div>
        </div>
        <div className="lg:col-span-5 font-script text-[12rem] lg:text-[18rem] leading-none text-terracotta/15 select-none">
          404
        </div>
      </section>
      <SiteFooter />
    </div>
  );
};

export default NotFoundPage;
